export const SalesmanActionTypes = {
    SET_CURRENT_SALESMAN: "SET_CURRENT_SALESMAN"
}